import { Injectable } from '@angular/core';
import { SortType, SortDirection } from '../constants-types/Enums';
import { SortInfo } from '../core-data-model/SortInfo.model';
import {
    ODataQueryGeneratorService,
    KeyValue,
    UnknownFilterTypeError
} from '../core-services/ODataQueryGenerator.service';

@Injectable({ providedIn: 'root' })
export class CognitiveAssessmentsQueryGeneratorService extends ODataQueryGeneratorService {
    getOrderbyParameter(sortingState: SortInfo[]): KeyValue[] {
        const sortList = sortingState.map((sortInfo: SortInfo) => {
            let oDataSort;
            const oDataDirection =
                sortInfo.direction === SortDirection.Ascending ? 'asc' : 'desc';
            if (sortInfo.sortType === SortType.RecentlySent) {
                oDataSort = 'assessmentSentDateTime';
            } else if (sortInfo.sortType === SortType.CognitiveScore) {
                oDataSort = 'score';
            } else {
                throw new UnknownFilterTypeError();
            }

            return `${oDataSort} ${oDataDirection}`;
        });
        if (sortList.length > 0) {
            return [
                {
                    key: '$orderby',
                    value: sortList.join(',')
                }
            ];
        }
        return [];
    }
}
